import { FC } from "react";
import { ColorBox } from "material-ui-color";
import { Box } from "@material-ui/core";

type ColorPickerWithAlphaProps = {
  propKey: string;
  color: string; // "#RRGGBB"
  alpha: number; // 0–1
  handleChange: (name: string, value: { color: string; alpha: number }) => void | Promise<void>;
};

// Converts 0–1 alpha to 2-digit hex (00–FF)
const alphaToHex = (alpha: number): string =>
  Math.round(alpha * 255).toString(16).padStart(2, "0");

// Converts 2-digit hex to 0–1 alpha
const hexToAlpha = (hex: string): number =>
  parseInt(hex, 16) / 255;

const toHexWithAlpha = (color: string, alpha: number): string => {
  const baseColor = color.replace("#", "").substring(0, 6);
  return `#${baseColor}${alphaToHex(alpha)}`;
};

const ColorPickerWithAlpha: FC<ColorPickerWithAlphaProps> = ({
  propKey,
  color,
  alpha,
  handleChange,
}) => {
  const handleColorChange = (newValue: { hex: string }) => {
    const fullHex = newValue.hex;
    const baseColor = `#${fullHex.substring(0, 6)}`;
    const alphaHex = fullHex.substring(6, 8);
    const updatedAlpha = alphaHex ? hexToAlpha(alphaHex) : 1;
    handleChange(propKey, { color: baseColor, alpha: updatedAlpha });
  };
  return (
    <Box sx={{ width: '100%' }}>
      <ColorBox
        value={toHexWithAlpha(color, alpha)}
        onChange={handleColorChange}
      />
    </Box>
  );
};

export default ColorPickerWithAlpha;
